import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Joiners from "@/pages/Joiners";
import JoinerProfile from "@/pages/JoinerProfile";
import Drops from "@/pages/Drops";
import DropDetail from "@/pages/DropDetail";
import Admin from "@/pages/Admin";
import ManageJoinersPage from "@/pages/ManageJoinersPage";
import RaffleLogPage from "@/pages/RaffleLogPage";
import PastDuePage from "@/pages/PastDuePage";
import CBRules from "@/pages/CBRules";
import SpecialDropDetail from "@/pages/SpecialDropDetail";
import InclusionsPage from "@/pages/InclusionsPage";
import InclusionDetail from "@/pages/InclusionDetail";

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/joiners" element={<Joiners />} />
            <Route path="/joiners/:id" element={<JoinerProfile />} />
            <Route path="/drops" element={<Drops />} />
            <Route path="/drops/:id" element={<DropDetail />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/joiners" element={<ManageJoinersPage />} />
            <Route path="/admin/raffles" element={<RaffleLogPage />} />
            <Route path="/admin/past-due" element={<PastDuePage />} />
            <Route path="/rules" element={<CBRules />} />
            <Route path="/special/:id" element={<SpecialDropDetail />} />
            <Route path="/inclusions" element={<InclusionsPage />} />
            <Route path="/inclusions/:id" element={<InclusionDetail />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
